import styled from 'styled-components'

export const BoxInfo = styled.div`
  height: 90vh;
  width: 90%;
  position: fixed;
  z-index: 1000;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  border-radius: ${props => props.theme.radius.card};
  border: 1px solid ${props => props.theme.colors.border.medium};
  box-shadow: 0 2px 8px ${props => props.theme.colors.shadow.strong};
  background: ${props => props.theme.colors.background.primary};
  visibility: ${({ showinfobox }) => (showinfobox === true || showinfobox === 'visible') ? 'visible' : 'hidden'};
  opacity: ${({ showinfobox }) => (showinfobox === true || showinfobox === 'visible') ? '1' : '0'};
  transform: ${({ showinfobox }) =>
    (showinfobox === true || showinfobox === 'visible')
      ? 'translate(-50%, -50%) scale(1)'
      : 'translate(-50%, -50%) scale(0.95)'
  };
  padding: 0;
  transition: all 0.3s ease;
  overflow: hidden;

  @media (max-width: 768px) {
    width: 95vw;
    height: 95vh;
    border-radius: ${props => props.theme.radius.card};
  }
`

export const BoxContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0;
  overflow-y: auto;
  overflow-x: hidden;

  /* Scrollbar themed */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: ${props => props.theme.colors.scrollbar.thumb};
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${props => props.theme.colors.scrollbar.thumbHover};
  }
`

export const ModalHeader = styled.div`
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.25rem 1.5rem;
  background: ${props => props.theme.colors.background.primary};
  border-bottom: 1px solid ${props => props.theme.colors.border.medium};
  transition: all 0.3s ease;

  h2 {
    margin: 0;
    font-size: 1.125rem;
    font-weight: 500;
    font-family: ${props => props.theme.typography.fontFamily};
    color: ${props => props.theme.colors.text.primary};
    letter-spacing: -0.02em;
  }

  @media (max-width: 768px) {
    padding: 20px 24px;

    h2 {
      font-size: 1.0625rem;
    }
  }
`

export const ModalBody = styled.div`
  flex: 1;
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  overflow-y: auto;
  overflow-x: hidden;

  /* Scrollbar styled */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: ${props => props.theme.colors.scrollbar?.thumb || props.theme.colors.border.medium};
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${props => props.theme.colors.scrollbar?.thumbHover || props.theme.colors.border.strong};
  }

  @media (max-width: 768px) {
    padding: 24px;
    gap: 20px;
  }
`

export const BoxRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1rem;
  border-radius: 6px;
  background: ${props => props.theme.colors.background.secondary};
  border: 1px solid ${props => props.theme.colors.border.medium};
  transition: all 0.2s ease;

  &:hover {
    background: ${props => props.theme.colors.background.hover};
    border-color: ${props => props.theme.colors.border.strong};
  }

  b {
    font-size: 0.75rem;
    font-weight: 600;
    font-family: ${props => props.theme.typography.fontFamily};
    color: ${props => props.theme.colors.text.tertiary};
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin-bottom: 0.25rem;
  }

  > *:not(b) {
    font-size: 0.875rem;
    font-family: ${props => props.theme.typography.fontFamily};
    color: ${props => props.theme.colors.text.primary};
    font-weight: 400;
    line-height: 1.5;
  }

  textarea {
    background: transparent;
    border: none;
    resize: none;
    font-family: inherit;
    font-size: 1rem;
    color: ${props => props.theme.colors.text.primary};
    min-height: 80px;
    outline: none;

    &:disabled {
      opacity: 1;
      color: ${props => props.theme.colors.text.primary};
    }
  }
`

export const BoxQr = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 1.5rem;
  border-radius: ${props => props.theme.radius.input};
  background: ${props => props.theme.colors.background.primary};
  border: 1px solid ${props => props.theme.colors.border.medium};
  position: relative;
  height: 25%;
  transition: all 0.3s ease;

  b {
    font-size: 0.75rem;
    font-weight: 600;
    font-family: ${props => props.theme.typography.fontFamily};
    color: ${props => props.theme.colors.text.tertiary};
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  #barcodeLabel {
    z-index: 1;
  }
`

export const BoxRowQr = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 1rem;
  background: ${props => props.theme.colors.background.primary};
  border-radius: ${props => props.theme.radius.input};
  box-shadow: 0 1px 2px ${props => props.theme.colors.shadow.light};
  border: 1px solid ${props => props.theme.colors.border.medium};
  height: 100%;
  transition: all 0.3s ease;

  svg {
    filter: drop-shadow(0 1px 2px ${props => props.theme.colors.shadow.light});
  }
`

export const PrintIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: ${props => props.theme.radius.input};
  background: ${props => props.theme.colors.semantic.primary};
  color: ${props => props.theme.colors.text.inverse};
  cursor: pointer;
  transition: ${props => props.theme.transitions.default};
  box-shadow: 0 1px 2px ${props => props.theme.colors.shadow.light};

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 4px ${props => props.theme.colors.shadow.medium};
    opacity: 0.9;
  }

  &:active {
    transform: translateY(0);
  }

  svg {
    width: 18px;
    height: 18px;
  }
`

export const CloseButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: ${props => props.theme.radius.input};
  background: ${props => props.theme.colors.background.hover};
  color: ${props => props.theme.colors.text.tertiary};
  cursor: pointer;
  transition: ${props => props.theme.transitions.default};
  border: 1px solid rgba(248, 113, 113, 0.2);

  &:hover {
    background: rgba(248, 113, 113, 0.15);
    border-color: rgba(248, 113, 113, 0.3);
    transform: scale(1.05);
    color: ${props => props.theme.colors.semantic.danger};
  }

  &:active {
    transform: scale(0.95);
  }

  svg {
    width: 18px;
    height: 18px;
  }
`

// Overlay per il backdrop blur
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${props => props.theme.colors.shadow.overlay};
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  z-index: 999;
  visibility: ${({ show }) => show ? 'visible' : 'hidden'};
  opacity: ${({ show }) => show ? '1' : '0'};
  transition: all 0.3s ease;
`

// Componente per le sezioni del contenuto
export const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const SectionTitle = styled.h3`
  font-size: 1.125rem;
  font-weight: 600;
  color: ${props => props.theme.colors.text.secondary};
  margin: 0;
  padding-bottom: 8px;
  border-bottom: 2px solid ${props => props.theme.colors.border.medium};
  transition: all 0.3s ease;
`

// Aggiunta per il componente BoxAggiuntaMateriale (mantenuto per compatibilità)
export const BoxAggiuntaMateriale = styled.div`
  height: 85vh;
  width: min(95vw, 1200px);
  max-height: 800px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 998;
  display: flex;
  flex-direction: column;
  border-radius: 20px;
  border: 1px solid ${props => props.theme.colors.border.medium};
  padding: 24px;
  box-shadow:
    0 25px 50px -12px ${props => props.theme.colors.shadow.strong},
    0 0 0 1px ${props => props.theme.colors.border.light};
  background: linear-gradient(135deg, ${props => props.theme.colors.background.primary} 0%, ${props => props.theme.colors.background.secondary} 100%);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  visibility: ${({ show }) => (show === true || show === 'visible') ? 'visible' : 'hidden'};
  opacity: ${({ show }) => (show === true || show === 'visible') ? '1' : '0'};
  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  overflow: hidden;

  @media (max-width: 768px) {
    width: 95vw;
    height: 90vh;
    padding: 16px;
  }
`
